var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('div',{staticStyle:{"margin-right":"3%"}},[_vm._v("Seg.")]),_c('div',{staticStyle:{"margin-right":"11%"}},[_vm._v("Tempo")]),_c('div',{staticStyle:{"margin-right":"31%"}},[_vm._v("Transcrição")]),_c('div',[_vm._v("Tradução")])])
}]

export { render, staticRenderFns }